export default __webpack_public_path__ + "static/media/depakine-810x425.84aacc4a.jpg";